document.addEventListener('DOMContentLoaded', function () {
	// Add 'three-cards' class if exactly 3 cards exist
	document.querySelectorAll('.horizontal-accordion').forEach(accordion => {
		if (accordion.querySelectorAll('.block-link-card').length === 3) {
			accordion.classList.add('three-cards');
		}
	});

	// jQuery accordion logic
	const $accordionItems = $('.horizontal-accordion .link-card');
	const $dotsContainer = $('.accordion-dots');
	const $nextBtn = $('.js-slider-controls .next');
	const $prevBtn = $('.js-slider-controls .prev');

	if (!$accordionItems.length) return;

	let currentIndex = 0;

	const setActiveItem = (index) => {
		$accordionItems.addClass('closed').each(function () {
			$(this).closest('.block-link-card').addClass('closed');
		});

		$accordionItems.eq(index).removeClass('closed').closest('.block-link-card').removeClass('closed');
		currentIndex = index;

		$dotsContainer.find('button').removeClass('active').eq(index).addClass('active');
	};

	// Generate dots
	$accordionItems.each((i) => {
		$('<button>', {
			type: 'button',
			'aria-label': `Go to item ${i + 1}`,
			class: i === 0 ? 'active' : '',
			click: () => setActiveItem(i)
		}).appendTo($dotsContainer);
	});

	// Initialize
	setActiveItem(0);

	// Click handler for items
	$accordionItems.on('click', function (e) {
		if (!$(this).hasClass('closed')) return;
		e.preventDefault();
		setActiveItem($accordionItems.index(this));
	});

	// Arrow navigation
	$nextBtn.on('click', () => setActiveItem((currentIndex + 1) % $accordionItems.length));
	$prevBtn.on('click', () => setActiveItem((currentIndex - 1 + $accordionItems.length) % $accordionItems.length));
});
